module.exports = __webpack_public_path__ + "img/reunion-193.b9398b46.jpg";